import React from 'react';
import { ExternalLinkIcon, QuoteIcon } from 'lucide-react';
import { Seo } from '../components/Seo';
import { PageHeader } from '../components/PageHeader';
import { Stars } from '../components/Stars';
import { CtaBand } from '../components/CtaBand';
import { useLanguage } from '../contexts/LanguageContext';
import { business } from '../data/business';
import { copy } from '../data/copy';
import { testimonials } from '../data/testimonials';
export function Reviews() {
  const {
    t,
    lang
  } = useLanguage();
  const page = copy.pages.reviews;
  return <>
      <Seo title={t(copy.seo.reviews.title)} description={t(copy.seo.reviews.description)} data-id="element-448" data-mp="11bgapz62f4wu" />
      <PageHeader eyebrow={t(page.eyebrow)} title={t(page.title)} description={t(page.description)} data-id="element-449" data-mp="rfcz82pbptx8" />

      <section className="bg-white py-14 sm:py-16" data-id="element-450" data-mp="383quorxqxqq6">
        <div className="mx-auto max-w-7xl px-6" data-id="element-451" data-mp="386394v4apiyh">
          <div className="flex flex-wrap items-center gap-x-8 gap-y-4 rounded-xl bg-navy-50 px-6 py-6" data-id="element-452" data-mp="3c6n8848fiwn9">
            <div className="flex items-center gap-3" data-id="element-453" data-mp="2qsl06ln1eeh">
              <span className="font-display text-4xl font-bold text-navy-900" data-id="element-454" data-mp="3tw0r9jq7fskm">
                {business.rating}
              </span>
              <span data-id="element-455" data-mp="bqo0gnm87vkb">
                <Stars rating={business.rating} size={18} data-id="element-456" data-mp="brz5srvblbdj" />
                <span className="mt-1 block text-sm text-navy-600" data-id="element-457" data-mp="7oaxu82s0drr">
                  {business.reviewCount} {t(copy.footer.googleReviews)}
                </span>
              </span>
            </div>
            <a href={business.reviewsUrl} target="_blank" rel="noreferrer" className="inline-flex min-h-[48px] items-center gap-2 rounded-md bg-navy-900 px-6 font-bold text-white transition-colors duration-150 ease-smooth hover:bg-navy-800 sm:ml-auto" data-id="element-458" data-mp="gq0nb8d3l2mw">
              {t(copy.cta.readAllGoogle)}
              <ExternalLinkIcon width={16} height={16} aria-hidden="true" data-id="element-459" data-mp="14d0c7of72o8z" />
            </a>
          </div>

          {lang === 'es' && <p className="mt-5 text-sm text-navy-500" data-id="element-460" data-mp="3t8hzddh99ihe">
              {t(page.translatedNote)}
            </p>}

          <ul className="mt-10 grid gap-6 lg:grid-cols-2" data-id="element-461" data-mp="22gnj2pgukup">
            {testimonials.map(testimonial => <li key={testimonial.name} className="h-full" data-id="element-462" data-mp="61pha7kiaiq9">
                <figure className="flex h-full flex-col rounded-xl p-7 ring-1 ring-navy-100" data-id="element-463" data-mp="auin6yrpnx3x">
                  <QuoteIcon width={28} height={28} aria-hidden="true" className="text-gold-300" data-id="element-464" data-mp="ftle7fauw2sw" />
                  <blockquote className="mt-4 leading-relaxed text-navy-700" data-id="element-465" data-mp="pqq3vp3wugeg">
                    “{t(testimonial.quote)}”
                  </blockquote>
                  <figcaption className="mt-auto flex flex-wrap items-center gap-x-4 gap-y-2 pt-6" data-id="element-466" data-mp="ts1vu1a9bdpt">
                    <span className="font-bold text-navy-900" data-id="element-467" data-mp="2rkflabsva6g6">
                      {testimonial.name}
                    </span>
                    <Stars rating={testimonial.rating} data-id="element-468" data-mp="2o0ozxn7hayy6" />
                    {testimonial.service && <span className="rounded-full bg-navy-50 px-3 py-1 text-xs font-semibold uppercase tracking-wide text-navy-600" data-id="element-469" data-mp="2ja8i7qwmkr60">
                        {t(testimonial.service)}
                      </span>}
                  </figcaption>
                </figure>
              </li>)}
          </ul>
        </div>
      </section>

      <CtaBand title={page.ctaTitle} description={page.ctaDescription} data-id="element-470" data-mp="36yrpq47uozx1" />
    </>;
}